import { useNavigate } from 'react-router-dom';
import { useDeviceStore } from '@/store/useDeviceStore';
import { useConnectionWizard } from '@/features/device/hooks/useConnectionWizard';

/**
 * Hook to handle "New Test" button logic
 * - If device is connected: navigate to measurement wizard
 * - If device is not connected: open connection wizard first
 * 
 * Note: Must match the same connection check as NewMeasurement.tsx to avoid race conditions
 */
export function useStartMeasurement() {
  const navigate = useNavigate();
  const { open: openConnectionWizard } = useConnectionWizard();
  const connectionState = useDeviceStore((s) => s.connectionState);
  
  // Connection is valid if we're in 'connected' or 'busy' state
  // Must match check in NewMeasurement.tsx to prevent flicker/race condition
  const isDeviceConnected = connectionState === 'connected';

  const startMeasurement = () => {
    if (isDeviceConnected) {
      // Device is connected, go straight to measurement wizard
      navigate('/measurement/new');
    } else {
      // Device not connected, open connection wizard
      // After successful connection, user will click "Start test" which navigates to measurement wizard
      openConnectionWizard();
    }
  };

  return { startMeasurement, isDeviceConnected };
}
